import { Trash2Icon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/** A deleted project, as only super admins still see it. */
export default function DeletedBadge() {
    const { t } = useTranslation();
    return (
        <span className="inline-flex shrink-0 items-center gap-1 rounded bg-red-50 px-1.5 py-0.5 text-[11px] font-medium text-red-700">
            <Trash2Icon className="h-3 w-3" />
            {t('Deleted')}
        </span>
    );
}
